module.exports = __webpack_public_path__ + "img/VIRUS_MALVADO.5d06aac1.png";